export const ACTION_TYPE_PRODUCTS_FETCHED    = 'PRODUCTS_FETCHED'
export const ACTION_TYPE_PRODUCTS_FETCHING   = 'PRODUCTS_FETCHING'
export const ACTION_TYPE_PRODUCT_CREATED     = 'PRODUCT_CREATED'
export const ACTION_TYPE_PRODUCT_UPDATED     = 'PRODUCT_UPDATED'
export const ACTION_TYPE_PRODUCT_DELETED     = 'PRODUCT_DELETED'
export const ACTION_TYPE_PRODUCT_CHECKING    = 'PRODUCT_CHECKING'
export const ACTION_TYPE_PRODUCT_SET_STATUS  = 'PRODUCT_SET_STATUS'
export const ACTION_TYPE_PRODUCT_SET_CURRENT = 'PRODUCT_SET_CURRENT'